module.exports = __webpack_public_path__ + "static/media/Stara_hora.5973cbaf.md";